export const GET_ALLREVIEWS_REQUEST = "GET_ALLREVIEWS_REQUEST";
export const GET_ALLREVIEWS_SUCCESS = "GET_ALLREVIEWS_SUCCESS";
export const GET_ALLREVIEWS_FAIL = "GET_ALLREVIEWS_FAIL";

export const GET_SINGLEREVIEW_REQUEST = "GET_SINGLEREVIEW_REQUEST";
export const GET_SINGLEREVIEW_SUCCESS = "GET_SINGLEREVIEW_SUCCESS";
export const GET_SINGLEREVIEW_FAIL = "GET_SINGLEREVIEW_FAIL";

export const GET_PRODUCTREVIEW_REQUEST = "GET_PRODUCTREVIEW_REQUEST";
export const GET_PRODUCTREVIEW_SUCCESS = "GET_PRODUCTREVIEW_SUCCESS";
export const GET_PRODUCTREVIEW_FAIL = "GET_PRODUCTREVIEW_FAIL";

export const CREATE_PRODUCTREVIEW_REQUEST = "GET_PRODUCTREVIEW_REQUEST";
export const CREATE_PRODUCTREVIEW_SUCCESS = "GET_PRODUCTREVIEW_SUCCESS";
export const CREATE_PRODUCTREVIEW_FAIL = "GET_PRODUCTREVIEW_FAIL";


export const UPDATE_REVIEW_REQUEST = "UPDATE_REVIEW_REQUEST";
export const UPDATE_REVIEW_SUCCESS = "UPDATE_REVIEW_SUCCESS";
export const UPDATE_REVIEW_FAIL = "UPDATE_REVIEW_FAIL";

